import { Component, Inject, OnInit } from '@angular/core';
import { BookmarkService } from '../bookmark.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-share-by-bookmark',
    templateUrl: './share-by-bookmark.component.html',
    styleUrls: ['./share-by-bookmark.component.scss'],
    standalone: false
})
export class ShareByBookmarkComponent implements OnInit {
  
  paramsData:any;
  shareByEmployeeEndPoint = "api/bookmarks/share-employee-bookmark";
  bookmarksByIdEndPoint = "api/bookmarks/get-shared-bookmarks-by-id"
  getModuleUsers = "api/bookmarks/get-module-users"
  bookmarkInnerGroup:any;
  bookmarkSearchText:any;
  reqSubcription: Subscription[] = [];
  loader = true;
  employee_key:any;
  bookmarkUsers:any = [];
  sharedBookmark:any;
  selectedAll:any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    private dialogRef: MatDialogRef<ShareByBookmarkComponent>,
    private bookmarkService: BookmarkService
  ) {
    // debugger
    this.loader = true;
    this.sharedLoader = false;
    this.paramsData = passedData;
    this.employee_key = passedData.employee_key;
    this.bookmarkInnerGroup = passedData.bookmark;
    this.getSharedBookmarkById(this.bookmarkInnerGroup);
   }


  ngOnInit(): void {}

  loadApiData(sharedBookmark:any) {
    
    if(this.bookmarkInnerGroup?.module_key) {
      let user:any = sessionStorage.getItem('userInformation')
      user = JSON.parse(user)

      let data = {module_key : this.bookmarkInnerGroup.module_key, user_type: user?.user_type || ''}
      this.reqSubcription.push(this.bookmarkService.bookMarkUpdateQuery(data, this.getModuleUsers).subscribe((res:any) => {
        if(res!=null && res?.length>0) {
          res = res.filter((f:any)=> f.employee_key != this.employee_key);
          let resData = res.map((m: any) => {
            m['checked'] = false;
            let findShared = sharedBookmark.find((f: any) => f.employee_key === m.employee_key);
            if (findShared) {
              m['checked'] = true;
            }
            return { ...m };
          })
          this.bookmarkUsers = this.disableSharedBookmarks(resData);
        } else {
          this.bookmarkUsers = [];
        }
        this.loader = false;
      })) 
    } else {
      this.loader = false;
      this.bookmarkUsers = [];
    }
  }

  getSharedBookmarkById(bookmark:any) {
    if(!bookmark?.bookmark_key) {
      this.loadApiData([]);
    };
    let data = {"bookmark_key": bookmark?.bookmark_key};
    this.bookmarkService.bookMarkUpdateQuery(data, this.bookmarksByIdEndPoint).subscribe((res:any) => {
      this.sharedBookmark = res?.length ? res : [];
      this.loadApiData(this.sharedBookmark);
    }, error => {
      this.loadApiData([]);
    })
  }
  
  error:any;
  sharedLoader = false;
  sharedBookmarkLoader = true;
  errorValue = false; 

  shareBookmarks(data:any) {
    let fndChecked = data.filter((f:any)=> f.checked && !f.disabled);
    if(fndChecked.length==0) {
      this.error = 'Please select atleast one user'
      return;
    } else {
      this.error = '';
    }; 
    this.sharedLoader = true;
    this.sharedBookmarkLoader = true;
    this.errorValue = false; 

    if(this.bookmarkInnerGroup?.employee_key && this.bookmarkInnerGroup?.bookmark_key) {
      const employee_key = fndChecked.map((item:any) => item.employee_key).join(', ');
      let payload = {
        "bookmark_key": this.bookmarkInnerGroup?.bookmark_key,
        "employee_key": employee_key
      }
      this.bookmarkService.bookMarkShareQuery(payload, this.shareByEmployeeEndPoint).subscribe((res:any) => {
        this.errorValue = true;
        this.sharedBookmarkLoader = true;
        this.function()
      }, error => {
        this.sharedBookmarkLoader = false;
        this.errorValue = true;
        if(error.status===200) {
          this.sharedBookmarkLoader = true;
          this.function()
        }
      })

    }
  }

  selectedAllChanges(selected: boolean) {
    this.bookmarkUsers = this.bookmarkUsers.map((user: any) => {
      if(user.disabled) {
        user.checked=true;
      } else {
        user.checked = selected
      }
      return {...user}
    });
  }

  gotItforValue() {
    if(this.sharedBookmarkLoader&&this.errorValue) {
      this.bookmarkUsers = this.disableSharedBookmarks(this.bookmarkUsers)
    }
    this.sharedLoader = false;
    this.errorValue = false;
    this.sharedBookmarkLoader = true;

    // this.hideTooltip()
  }
  

  disableSharedBookmarks(bookmarkUsers:any) {
    return bookmarkUsers.map((user: any) => {
      if(user.checked) {
        user.disabled = true;
      } else {
        user.disabled = false;
      }
      return { ...user}
    }).sort((a: any, b: any) => {
      return Number(b.checked) - Number(a.checked);
    });
  }

  hideTooltip() {
    this.dialogRef.close(false)
  }

  function() {
    const circleLoader:any = document.querySelector('.circle-loader');
    const checkmark:any = document.querySelector('.checkmark');
    
    circleLoader.classList.toggle('load-complete');
    checkmark.style.display = (checkmark.style.display === 'none' || checkmark.style.display === '') ? 'block' : 'none';
  };

  ngOnDestroy(): void {
    this.reqSubcription.forEach(res => res.unsubscribe())
  }
}
